module.exports = __webpack_public_path__ + "static/media/icon-arrowhead.a2d32ab7.svg";